import { useState } from 'react';
import Modal from 'components/Modal';
import Button from 'components/Button';
import SC from './style';

interface Slots {
  used: number;
  remaining: number;
  max: number;
}

interface UnlockTrainingPopUpProps {
  slots: Slots;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const UnlockTrainingPopUp: React.FC<UnlockTrainingPopUpProps> = ({
  slots, loading, onConfirm, onClose,
}) => {
  const [consent, setConsent] = useState(false);

  const limitReached = slots.remaining <= 0;
  const willReachLimit = slots.remaining === 1;

  return (
    <Modal onClose={onClose}>
      <SC.DivUnlock>
        {limitReached ? (
          <>
            <p css={SC.title}>Vous avez atteint la limite de formations en cours</p>
            <p css={SC.description}>
              En tant qu&apos;abonné Expertise, vous pouvez suivre jusqu&apos;à
              {' '}
              {slots.max}
              {' '}
              formations en parallèle. Terminez
              l&apos;une de vos formations en cours pour pouvoir en démarrer une nouvelle.
            </p>
            <div css={SC.actions}>
              <Button value="J'ai compris" onClick={onClose} />
            </div>
          </>
        ) : (
          <>
            <p css={SC.title}>Démarrer cette formation</p>
            <p css={SC.description}>
              Votre abonnement Expertise vous donne accès à l&apos;ensemble du catalogue, dans la limite de
              {' '}
              {slots.max}
              {' '}
              formations suivies en parallèle.
            </p>

            {willReachLimit && (
              <p css={SC.warning}>
                En démarrant cette formation, vous atteindrez la limite de
                {' '}
                {slots.max}
                {' '}
                formations en cours. Vous devrez en
                terminer une avant d&apos;en commencer une nouvelle.
              </p>
            )}

            <SC.LabelConsent>
              <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
              <span>
                Je confirme avoir pris connaissance des objectifs et pré-requis et que cette formation répond à mon besoin
                professionnel.
              </span>
            </SC.LabelConsent>

            <div css={SC.actions}>
              <Button
                value="Oui, je commence cette formation"
                onClick={onConfirm}
                loading={loading}
                disabled={!consent || loading}
              />
              <SC.ButtonDecline type="button" onClick={onClose}>
                Non, je ne souhaite pas démarrer
              </SC.ButtonDecline>
            </div>
          </>
        )}
      </SC.DivUnlock>
    </Modal>
  );
};

export default UnlockTrainingPopUp;
